/** @jsxImportSource @emotion/react */
import { StageV2 } from 'modules/championship/domain/interfaces/stage';
import { fetchStageStatistics } from 'modules/championship/store/stages/stages.actions';
import { Table } from 'modules/championship/ui/components/form-parts/stages/stage-grid/stage-group/stage-group-table';
import { msg } from '@lingui/core/macro';
import React, { useEffect } from 'react';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';
import type { DivProps } from 'typings';
import * as S from './styles';

interface IStageStandingProps extends DivProps {
  stage: StageV2;
}

function StageStanding(props: IStageStandingProps) {
  const dispatchWithToast = useDispatchWithToast();
  const { stage, ...rest } = props;

  // `stage.id` в зависимостях обязателен: экран этапа больше не размонтируется
  // при смене `:stageId` в адресе, поэтому без него осталась бы статистика
  // предыдущего этапа.
  useEffect(() => {
    // Раньше провал молчал: таблица оставалась пустой без объяснения.
    dispatchWithToast(fetchStageStatistics({ stageId: stage.id }), { error: msg`Не удалось загрузить таблицу этапа` });
  }, [dispatchWithToast, stage.id]);

  return (
    <S.MainBlock {...rest}>
      <Table isEditMode={false} teams={stage.teams} statistics={stage.statistics ?? []} />
    </S.MainBlock>
  );
}

export default StageStanding;
